export default __webpack_public_path__ + "static/media/v1play.ef897948.png";